/* IMPORT */
import { setBatch } from '../context.js';
import { noop } from '../utils.js';
/* HELPERS */
let counter = 0;
let resolve = noop;
/* MAIN */
const batch = async (fn, stack) => {
    if (!counter) {
        setBatch(new Promise(r => resolve = r));
    }
    try {
        counter += 1;
        return await fn();
    }
    finally {
        counter -= 1;
        if (!counter) {
            setBatch(undefined);
            resolve(stack);
        }
    }
};
/* MAIN */
export default batch;
